import React from 'react';
import { useShowContext } from 'framework/show';
import { useArtifactService, useArtifactDownloadHelper, useArtifactPreviewHelper } from 'domain/shared/artifact';
import { getLabel, useAsyncValue } from 'framework/utils';
import { useUiTheme } from 'framework/uiTheme';
import { InputLoader } from 'framework/ui/mui-builder';

type InvoiceAttachmentsListFieldProps = {
  source: string;
  value?: string[] | undefined;
  label: string;
  isDownloadAvailable?: boolean;
  isOneArtifact?: boolean;
  width?: any;
};

const InvoiceAttachmentsListField: React.FC<InvoiceAttachmentsListFieldProps> = ({
  source,
  value: inputValue,
  label: propsLabel,
  isDownloadAvailable = true,
  isOneArtifact = false,
}) => {
  const { AttachmentsListLayout, BaseFieldLayout } = useUiTheme();

  const { data } = useShowContext();
  const label = getLabel(propsLabel, source);
  const { getInvoiceArtifactsDataByIds, getInvoiceThumbnail } = useArtifactService();
  const attachmentsIds = inputValue || (data && data.getValueBySource(source)) || [];

  // @ts-ignore
  const invoiceId = data.id;

  const attachments = useAsyncValue(async () =>
    getInvoiceArtifactsDataByIds(invoiceId, isOneArtifact ? [attachmentsIds] : attachmentsIds),
  );

  const { downloadForInvoice } = useArtifactDownloadHelper();
  const { openPreviewForInvoice } = useArtifactPreviewHelper();

  return attachments ? (
    <AttachmentsListLayout
      attachments={attachments}
      label={label}
      downloadFile={() => downloadForInvoice(invoiceId)}
      getThumbnail={(id: number | string, cropSize: string) => getInvoiceThumbnail(invoiceId, id, cropSize)}
      openPreview={() => openPreviewForInvoice(invoiceId)}
      isDownloadAvailable={isDownloadAvailable}
    />
  ) : (
    <BaseFieldLayout label={label} value={<InputLoader />} />
  );
};

export default InvoiceAttachmentsListField;
